var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.364 10.59-2.686 1.506a.6.6 0 0 1-.881-.64l.6-3.026a.6.6 0 0 0-.181-.557L.953 5.778a.6.6 0 0 1 .337-1.036L4.35 4.38a.6.6 0 0 0 .474-.345l1.29-2.8a.6.6 0 0 1 1.09 0l1.29 2.8a.6.6 0 0 0 .473.345l3.059.363a.6.6 0 0 1 .337 1.036l-2.263 2.095a.6.6 0 0 0-.18.557l.6 3.026a.6.6 0 0 1-.882.64L6.95 10.59a.6.6 0 0 0-.587 0Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};
export default SvgStar;